import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { authService } from '@/services/auth'
import { ROUTES } from '@/constants/routes'

// renders children when the user is authenticated, otherwise redirects to login
// preserves the attempted URL in state so login can redirect back after success
export function RequireAuth() {
  const location = useLocation()

  if (!authService.isAuthenticated()) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return <Outlet />
}
